//import router from './router'
import ENV from '../../api/env.js'
import store from '@/store/index'
import { Message } from 'element-ui'
import base from '@/api/base.js'; // 导入接口域名列表
import api from '@/api/index.js'; // 导入axios实例

(function(w) { //定义立即执行函数，传入全局对象window  
    //封装获取dom的方法
    function myquery(elem) { //定义函数，实现去new的操作，  
        function Art(elem) { //定义类
            //dom对象
            if( typeof(elem)==='object' ){
                this.ele = elem;
            }
            //选择器str
            else if( typeof(elem)==='string' ){
                var len = document.querySelectorAll(elem).length;
                if( len>1 ){
                    this.ele = document.querySelectorAll(elem); 
                }else{
                    this.ele = document.querySelector(elem); 
                }
            }
            return this; //返回对象
        }
        
        Art.prototype = {
            constructor: Art,
            //length
            length: new Art(elem).ele ? ( new Art(elem).ele.length>1 ? new Art(elem).ele.length : 1 ) : 0,
            //html()
            html: function(val) { //利用原型添加设置html的方法
                this.ele.innerHTML = val;
                return this; //返回对象，执行后可链式操作
            },
            //attr()
            attr: function(key, val) { //添加设置属性的方法
                this.ele.setAttribute(key, val);
                return this;
            },
            //css()
            css: function(key,val){
                this.ele.style[key] = val;
                return this;
            },
            //on()
            on: function(event, fun){
                var len = this.length;
                if( len===1 ){
                    this.ele.addEventListener(event, fun, false);
                    //this.ele['on'+event] = function(){alert(1)}//fun;
                }else{
                    for( var i=0; i<len; i++ ){
                        this.ele[i].addEventListener(event, fun, false);
                        //this.ele[i]['on'+event] = fun;
                    }
                }
                return this;
            },
            //off()
            off: function(event, fun){
                var len = this.length;
                if( len===1 ){
                    this.ele.removeEventListener(event, fun, false);
                    this.ele['on'+event] = null;
                }else{
                    for( var i=0; i<len; i++ ){
                        this.ele[i].removeEventListener(event, fun, false);
                        this.ele[i]['on'+event] = null;
                    }
                }
                return this;
            },
            //hasClass
			hasClass: function(cls){
				cls = cls || '';
				if (cls.replace(/\s/g, '').length == 0) return false; //当cls没有参数时，返回false
                var reg = new RegExp(' '+cls+' ','g');
                if( !this.ele ){return false;} //未解决ie报错
				return reg.test(' ' + this.ele.className + ' ');
			},
			//addClass
			addClass: function(cls) {
                var hasClass = this.hasClass(cls);
                if(!this.ele){return this;}
				if ( !hasClass ){
					var len = this.ele.length;
					if( len && len>0 ){
						for( var i=0; i<len; i++ ){
							this.ele[i].className = this.ele[i].className=='' ? cls : this.ele[i].className + ' ' + cls;
						}
					}else{
						this.ele.className = this.ele.className=='' ? cls : this.ele.className + ' ' + cls;
					}
				}
				return this;
			},
			//removeClass
			removeClass: function(cls){
				var oldClass,newClass;
				var len = this.ele.length;
				if( len && len>0 ){
					for( var i=0; i<len; i++ ){
						oldClass = (' '+this.ele[i].className+' ').replace(/(\s+)/gi, ' ');
						newClass = oldClass.replace(' '+cls+'',' ').replace(/(^\s+)|(\s+$)/g, '');
						this.ele[i].className = newClass;
					}
				}else{
					oldClass = (' '+this.ele.className+' ').replace(/(\s+)/gi, ' ');
					newClass = oldClass.replace(' '+cls+'',' ').replace(/(^\s+)|(\s+$)/g, '');
					this.ele.className = newClass;
				}
				return this;
            },
            //parent
			parent: function(elem){
				var p = this.ele.parentNode;
				return new Art(p);
			},
			//parents()
			parents: function(elem){
				var p = this.ele.parentNode;
				var targetP = art(elem).ele;
				var parents = [];
				if( !targetP.length>0 ){
					targetP = [targetP];
				}
				function check(){
					for( var i=0; i<targetP.length; i++ ){
						if( p===targetP[i] ){
							parents.push(p);
						}
						if( p===document.body ){
							return true;
						}
					}
					p = p.parentNode;
					check();
				}
				check();
				var targetArr = [];
				for( var j=0; j<parents.length; j++ ){
					targetArr.push( new Art(parents[j]) );
				}
				return targetArr;
			}
        }

        return new Art(elem); //去new处理，返回实例对象
    }

    var artFun = {

		ossurl: 'http://artapp-'+(ENV==2 ? 'dev' : 'test')+'-bucket.oss-cn-beijing.aliyuncs.com/',
        ossurl1: 'https://artapp-'+(ENV==2 ? 'dev' : 'test')+'-bucket.oss-cn-beijing.aliyuncs.com/',
        courseDefaultCover: 'studio_course/ff3cd517-f694-4256-9347-173ad9c312d9.jpg', //课程默认封面图
		activityDefaultCover: 'studio_activity/23ef419c-2226-4a61-97c4-f24b22d754f8.jpg', //活动默认封面图
        liveDefaultCover: 'live/7539b9e3-cae4-4279-b8f1-0103e250dbe7.png', //直播封面图
        defaultHeadPhoto: 'studio_course/5a449bb0-d959-4fae-862a-ef3056931bbf.png', //默认封面图studio_course/5a449bb0-d959-4fae-862a-ef3056931bbf.png@/assets/img/default-headphoto.png
        defaultInstCover: 'user_address/d6752054-4af9-4292-b53b-b9c4bb6857e1.png',//机构默认封面图

		//地址栏获取参数
		getUrlData: function(parament) {
			var reg = new RegExp("(^|&)" + parament + "=([^&]*)(&|$)"); // 构造一个含有目标参数的正则表达式对象
			var r = window.location.search.substr(1).match(reg); // 匹配目标参数
			if (r != null) {
				return decodeURIComponent(r[2]);
			} else {
				return null; //返回参数值
			}
        },
        
        //登录成功
        loginSuc: function(data){
            var thisTime = new Date().getTime();
            var deadTime = thisTime + 60*60*1000*7; //token过期时间7小时
            var loginUserInfo = {
                token: data.token,
                deadTime: deadTime,
                user: data.body.User,
            } 
            localStorage.loginUserInfo = JSON.stringify(loginUserInfo);
            //store.dispatch('tokenStatus/updateTaken', data.authToken);//设置token
            //store.dispatch('tokenStatus/set_deadtime', deadTime);//设置token
            store.commit('tokenStatus/set_token',data.authToken);
            store.commit('tokenStatus/set_deadtime',deadTime);
        },

		//获取token
		getToken: function() {
            var res = this.checkLoginInfo();
			if (!res.success) {
                Message.error(res.msg);
				//this.toLogin();
			}
			return res.token;
		},

		//弹出登录页面
		toLogin: function() {
            console.log('登录');
		},

		//检查是否还有登录信息，或者token是否失效，return true/false
		checkLoginInfo: function() {
			var loginUserInfo = localStorage.loginUserInfo; //登录信息
			//1.登录信息获取token不存在，return false
			if (!loginUserInfo) {
                return {success:false,status:0,msg:'尚未登录，请先登录！'};
            }
			loginUserInfo = JSON.parse(loginUserInfo);
			var deadTime = loginUserInfo.deadTime; //token过期时间
			//2当前时间-1s>deadline，return false
			if (new Date().getTime() >= deadTime) {
				return {success:false,status:-1,msg:'登录信息失效，请重新登录'};
			}
			return {
                success:true,
				token: loginUserInfo.token,
			};
		},

		//数据除以100，（数组）
		divide100: function(data,nofushu) {
			var that = this;
			var type = typeof(data);
			var newData = '';
			//string
			if (type === 'string' && parseFloat(data) !== NaN) {
				newData = that.multiply(parseFloat(data),0.01);
			}
			//number
			if (type === 'number') {
				newData = that.multiply(data,0.01);
			}
			//数组
			if (type === 'object' && data.length >= 0) {
				newData = [];
				for (var i = 0; i < data.length; i++) {
					//负数变0
					if(nofushu){
						newData[i] = data[i]<0 ? 0 : that.multiply(data[i],0.01);
					}else{
						newData[i] = that.multiply(data[i],0.01);
					}
				}
			}
			return newData;
		},

		//初始化client
		initOssClient: function(){
			window.client = new OSS.Wrapper({
				region: "oss-cn-beijing",
				secure: true,
				accessKeyId: "X8T0w0VNj6ZrMej4",
				accessKeySecret: "VziKfO9oXMINPnvzaJNcgcvE0mYWCq",
				bucket: "artapp-dev-bucket"
			});
			client.options.endpoint.protocol = "https:";
		},

		/* 上传资源到oss服务器
		 * fileObj：file对象    input.files[0]得到
		 * lei：           image-图片， video-视频
		 * folder：  上传oss新建的文件夹名称
		 * suc:    成功回调
		 * err:    失败回调
		 * onlypng: 是否图片格式jpg强行改成png
		 * */
		UpFileToOssOld: function(file, lei, folder, suc, err, onlypng) {
			if (!file) {
				return;
			}
			var val = file.name; //filename
			//console.log(file);
			var suffix = val.substr(val.lastIndexOf('.')); //获取后缀（如： .png）
			suffix = suffix.toLowerCase();
			suffix = suffix.replace(/.jpeg/gi, ".jpg");
			if (onlypng == true) {
				suffix = suffix.replace(/.jpg/gi, ".png");
			}
			var storeAs = folder + "/" + artTool.getUuid() + suffix;
			client.multipartUpload(storeAs, file).then(function(res) {
				suc(storeAs);

			}).catch(function(res) {
				err(res);
			});
        },
        //新的上传
        UpFileToOss: function (file, lei, folder, suc, err, onlypng, progress1,fullSrc) {
            var that = this;
            var vm = this;
            if (!file) { return; }
            var storeAs = clacName(file);
            getOssUploadGetSecurityToken(function(d){
                upOss(d);
            });
            //计算文件名
            function clacName(file){
                var val = file.name;//filename
                var suffix = val.substr(val.lastIndexOf('.')); //获取后缀（如： .png）
                suffix = suffix.toLowerCase();
                suffix = suffix.replace(/.jpeg/gi, ".jpg");
                if (onlypng == true) {
                    suffix = suffix.replace(/.jpg/gi, ".png");
                }
                //var storeAs = folder + "/" + artTool.getUuid() + suffix;
                var storeAs = folder + suffix;
                return storeAs;
            }
            function upOss(d){
                var client = new OSS.Wrapper({
                    //后台给的
                    region: "oss-cn-beijing",
                    secure: true,
                    accessKeyId: d.accessKeyId,
                    accessKeySecret: d.accessKeySecret,
                    bucket: d.bucketName,
                    stsToken: d.securityToken,
                    //原来的
                    // region: "oss-cn-beijing",
                    // secure: true,
                    // accessKeyId: "X8T0w0VNj6ZrMej4",
                    // accessKeySecret: "VziKfO9oXMINPnvzaJNcgcvE0mYWCq",
                    // bucket: "artapp-dev-bucket"
                });
                client.options.endpoint.protocol = "https:";
                let storeAs= d.object;
                client.multipartUpload(storeAs, file).then(function (res) {
                    suc(fullSrc ? d.host+'/'+storeAs : storeAs);
                }).catch(function (res) {
                    err(res);
                });
            }
            function getOssUploadGetSecurityToken(callback){
                let webUploadSign = sessionStorage.getItem('instWebUploadSign');
                let needUpdate = false;
                if(webUploadSign){
                    webUploadSign = JSON.parse(webUploadSign);
                    let expiration = webUploadSign.expiration;
                    let now = Date.parse(new Date());
                    if(expiration<now + 3000) needUpdate = true;
                }
                else{
                    needUpdate = true;
                }
                if(needUpdate){
                    api.pub.ossUploadGetSecurityTokenWithSign({object:storeAs})
                    .then((res) => {
                        var webUploadSign = res.body.webUploadSign;
                        //sessionStorage.setItem('instWebUploadSign',JSON.stringify(webUploadSign))
                        callback(webUploadSign);
                    })
                    .catch((res) => {});
                }
                else{
                    callback(webUploadSign);
                }
            }
        },
        
        //视频封面图转成正常图片
        getNewImgUrl: function (url, dir, suc, err) {
            //把图片转成base64，然后上传oss,得到新的地址
            var art = this;
            var img = url; //oss的图片转base64报跨域错，可能需要配置
            art.getBase64Image(img, function (base64) {
                var file = art.dataURItoFile(base64, 'xxx.png');
                art.UpFileToOss(file, "image", dir, function (url) {
                    suc(url);
                }, function (res) {
                    console.log(res,'上传失败');
                    err(res);
                });
            });
        },

        //图片地址变成base64
        getBase64Image: function (url, callback) {
            var img = new Image();
            img.setAttribute("crossOrigin", 'Anonymous');
            img.setAttribute("crossOrigin", '*');
            img.src = url;
            img.onload = function () {
                try {
                    var canvas = document.getElementById("mycanvasForBase64Image");//获取canvas
                    if (!canvas) {
                        canvas = document.createElement("canvas");
                        canvas.id = 'mycanvasForBase64Image';
                        canvas.style.display = 'none';
                        document.body.appendChild(canvas);
                    }
                    canvas.width = img.width;
                    canvas.height = img.height;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, img.width, img.height);
                    var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
                    var dataURL = canvas.toDataURL("image/png", 1);
                    callback(dataURL);
                } catch (err) {
                    art.getBase64Image(switchHttps(url), callback);
                }
            }
            function switchHttps(url) {
                var str = url.toLowerCase();
                if (str.slice(0, 4) === 'http') {
                    if (str.slice(4, 5) === 's') {
                        return str.replace('https://', 'http://');
                    } else {
                        return str.replace('http://', 'https://');
                    }
                }
            }
        },

		//获取时间戳字符串
		timestamp: function() {
			var time = new Date();
			var y = time.getFullYear();
			var m = time.getMonth() + 1;
			var d = time.getDate();
			var h = time.getHours();
			var mm = time.getMinutes();
			var s = time.getSeconds();
			return "" + y + artTool.add0(m) + artTool.add0(d) + artTool.add0(h) + artTool.add0(mm) + artTool.add0(s);
		},

		//生成guid
		getUuid: function() {
			var s = [];
			var hexDigits = "0123456789abcdef";
			for (var i = 0; i < 36; i++) {
				s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
			}
			s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010 
			s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01 
			s[8] = s[13] = s[18] = s[23] = "-";
			var uuid = s.join("");
			return uuid;
		},

		//小于10，前面加零
		add0: function(x) {
			if (x === undefined || typeof(x) !== 'number') {return '';}
			if (x < 10) {x = '0' + x;}
			return x;
		},

		//建立一個可存取到該file的url
		getObjectURL: function(file) {
			var url = null;
			if (window.createObjectURL != undefined) {
				url = window.createObjectURL(file);
			} else if (window.URL != undefined) {
				url = window.URL.createObjectURL(file);
			} else if (window.webkitURL != undefined) {
				url = window.webkitURL.createObjectURL(file);
			}
			return url;
		},

		//图片 base64 转换成=> file 
		dataURItoFile: function(dataURI, fileName) {
			var byteString = atob(dataURI.split(',')[1]);
			var ab = new ArrayBuffer(byteString.length);
			var ia = new Uint8Array(ab);
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			//return new Blob([ab], { type: 'image/jpeg' }); 
			return new File([ia], fileName, {
				type: 'image/jpeg',
				lastModified: Date.now()
			})
		},

		//只能输入正数（不能小数点）
		limitInput1: function(obj,max,min) {
			obj.value = obj.value.replace(/[^\d]/g, '');
			obj.value = obj.value.replace(/[^\d]/g, '');
			var val = parseFloat(obj.value);
			if( max || max===0 ){
				if( val>max ){ obj.value = max }
			}
			if( min || min===0 ){
				if( val<min ){ obj.value = min }
			}
		},

		//只能输入正数（可以输入小数点2位）
		limitInput2: function(obj, num,max,min) {
			var pat = /[^\d.]/g;
			obj.value = obj.value.replace(/[^\d.]/g, '');
			if (num === 1) {
				obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3');
			}
			if (num === 2) {
				obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
			}
            var val = parseFloat(obj.value);
            if( max || max===0 ){
				if( val>max ){ obj.value = max }
			}
			if( min || min===0 ){
				if( val<min ){ obj.value = min }
			}
		},

		//只能输入数字（可以小数点、负数）
		limitInput3: function(obj,num) {
			obj.value = obj.value.replace(/[^\-?\d.]/g,'')
		},

		//时间戳转换年-月-日
		formatDate: function(str, type) {
			if (!str || str == ' ') {
				//var now = new Date();
				return '';
			} else {
				var now = new Date(str);
			}
			var year = now.getFullYear() + "";
			var month = now.getMonth() + 1 + "";
			var date = now.getDate() + "";
			var hour = now.getHours() + "";
			var minute = now.getMinutes() + "";
			var second = now.getSeconds() + "";
			if (month.length < 2) {
				month = "0" + month;
			}
			if (date.length < 2) {
				date = "0" + date;
			}
			if (hour.length < 2) {
				hour = "0" + hour;
			}
			if (minute.length < 2) {
				minute = "0" + minute;
			}
			if (second.length < 2) {
				second = "0" + second;
			}
			if (type == 1) {
				return year + "-" + month + "-" + date + ' ' + hour + ':' + minute;
			} else if (type == 2) {
				return year + "-" + month + "-" + date;
			} else if (type == 3) {
				return year + month + date;
			}else if (type == 4) {
				return year +'/'+ month +'/'+ date;
			}

		},

		//计算数据差，返回天，时，分、秒
		calcTime: function(thatTime) {
			var that = this;
			if (!thatTime && thisTime !== 0) {
				return false;
			}
			var thatTime = new Date(thatTime).getTime();
			var thisTime = new Date().getTime();
			var difNum = thatTime - thisTime;
			var ts = Math.abs(thatTime - thisTime);
			var d = parseInt(ts / 1000 / 60 / 60 / 24);
			var h = parseInt(ts / 1000 / 60 / 60 % 24);
			var m = parseInt(ts / 1000 / 60 % 60);
			var s = parseInt(ts / 1000 % 60);
			var dd = (d === 0) ? '' : (d + '天');
			var hh = (h === 0) ? '' : (that.add0(h) + '时');
			var mm = (m === 0) ? '' : (that.add0(m) + '分');
			var ss = (s === 0) ? '' : (that.add0(s) + '秒');
			return {
				str: dd + hh + mm + ss,
				d: d,
				h: h,
				m: m,
				s: s,
				difNum: difNum
			}
		},
		
		//判断是否是二进制URL
		isBlosUrl: function(url){
			var urlHead = 'blob:'+location.protocol+'//'+location.host; //二进制地址开头
			var reg = new RegExp('^('+urlHead+')', 'i');
			return reg.test(url);
		},

		/*oss方法压缩图片
		 * maxw: 允许最大宽度， maxh:允许最大高度 （满足一个即可）
		 */
		addOssResize: function(url, maxw, maxh) {
			if (!url) {return '';}
			if( this.isBlosUrl(url) ){return url;} //二进制url
			if (!maxw && !maxh) {return url;}
			var newurl = '';
			var reg = /(\/resize,m_mfit)+((,w_\d+)|(,h_\d+)){1,2}/gi;
			//已经有压缩
			if (url.indexOf('/resize,m_mfit,') > 0) {
				//只有最大宽度maxw
				if (maxw && !maxh) {
					newurl = url.replace(reg, '/resize,m_mfit,w_' + maxw);
				}
				//只有最大高度maxh
				if (!maxw && maxh) {
					newurl = url.replace(reg, '/resize,m_mfit,h_' + maxh);
				}
				//maxw、maxh都有
				if (maxw && maxh) {
					newurl = url.replace(reg, '/resize,m_mfit,w_' + maxw + ',h_' + maxh);
				}
			}
			//没有压缩
			else {
				if (url.indexOf('?x-oss-process=image/') > 0) {
					newurl = url + '/resize,m_mfit';
				}else {
					if( url.indexOf('?x-oss-process=') > 0 ){
						newurl = url + '&x-oss-process=image/resize,m_mfit';
					}else{
						newurl = url + '?x-oss-process=image/resize,m_mfit';
					}
				}
				//有maxw
				if (maxw) {
					newurl += ',w_' + maxw;
				}
				//有maxh
				if (maxh) {
					newurl += ',h_' + maxh;
				}
			}
			return this.addOssurlHeader(newurl);
		},

		//处理oss地址,有就不加头部
		addOssurlHeader: function(url) {
            if(!url) return '';
            var that = this;
            var i1 = url.indexOf('http');  //http开头就不加，（包括直播回放地址myqcloud.com/）
            var i2 = url.indexOf('data:image/'); //base64图片不加
            if( i1==0 || i2==0 ){ 
                return url;
            }else{
                var newurl = that.removeOssurlHeader(url);
                return that.ossurl + newurl;
            }
		},
        //去掉oss地址前缀
        removeOssurlHeader: function (url) {
            if(!url) return;
            var i = url.indexOf('-bucket.oss-cn-beijing.aliyuncs.com/'); //第一次出现的位置
            if(i>0) url = url.substr(i+36);
            return url;
        },

		//获取oss视频的封面图
		getOssVideoSnapshot: function(url, t, f, w, h) {
			var that = this;
			if (!url) {return '';} //视频地址
			if (!t) {return url;}  //时刻（截取什么时刻的屏）
			if (!f) {f = 'png';}   //图片格式
			if (!w) {w = 0;}       //图片宽
			if (!h) {h = 0;}       //图片高
			var k = '2a80538793e14.mp4?x-oss-process=video/snapshot,t_10,f_jpg,h_0,w_1000,m_fast';
			var reg = /(\/snapshot,t_\d+)(,f_(jpg|png))((,w_\d+)|(,h_\d+)){1,2}(,m_fast){0,1}/gi;
			var newurl = ';'
			//已经有截幁
			if (url.indexOf('/snapshot,t_') > 0) {
				newurl = url.replace(reg, '/snapshot,t_' + t + ',f_' + f + ',w_' + w + ',h_' + h + ',m_fast');
			} else {
				if (url.indexOf('?x-oss-process=video') > 0) {
					newurl = url + '/snapshot,t_' + t + ',f_' + f + ',w_' + w + ',h_' + h + ',m_fast';
				} else {
					newurl = url + '?x-oss-process=video/snapshot,t_' + t + ',f_' + f + ',w_' + w + ',h_' + h + ',m_fast';
				}
			}
			return that.addOssurlHeader(newurl);
		},

		//base64安全编码（用于oss生成文字水印）
		base64encode: function(input) {
			var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=";
			var output = "";
			var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
			var i = 0;
			input = _utf8_encode(input);
			while (i < input.length) {
				chr1 = input.charCodeAt(i++);
				chr2 = input.charCodeAt(i++);
				chr3 = input.charCodeAt(i++);
				enc1 = chr1 >> 2;
				enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
				enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
				enc4 = chr3 & 63;
				if (isNaN(chr2)) {
					enc3 = enc4 = 64;

				} else if (isNaN(chr3)) {
					enc4 = 64;
				}
				output = output +
					_keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
					_keyStr.charAt(enc3) + _keyStr.charAt(enc4);
			}
			// private method for UTF-8 encoding 
			function _utf8_encode(string) {
				string = string.replace(/\r\n/g, "\n");
				var utftext = "";
				for (var n = 0; n < string.length; n++) {
					var c = string.charCodeAt(n);
					if (c < 128) {
						utftext += String.fromCharCode(c);
					} else if ((c > 127) && (c < 2048)) {
						utftext += String.fromCharCode((c >> 6) | 192);
						utftext += String.fromCharCode((c & 63) | 128);
					} else {
						utftext += String.fromCharCode((c >> 12) | 224);
						utftext += String.fromCharCode(((c >> 6) & 63) | 128);
						utftext += String.fromCharCode((c & 63) | 128);
					}

				}
				return utftext;
			}
			return output;
		},

		//检查url地址是图片、视频、音频
		checkSourceUrlType: function(url) {
			if (!url) return false;
			var url = url.toLowerCase();
			var len = url.lastIndexOf('.');
			var typestr = url.slice(len + 1);
			if (typestr == 'jpg' || typestr == 'jpeg' || typestr == 'png' || typestr == 'gig' || typestr == 'bmp') {
				return 'image';
			} else if (typestr == 'mp3') {
				return 'audio';
			} else if (typestr == 'mp4' || typestr == 'ogg' || typestr == 'avi' || typestr == 'flv') {
				return 'video';
			} else {
				return false;
			}
		},

		//控制文字超过显示...
		wrapWordsNum: function(v) {
			var text = v;
			var base = 10; //默认10个字
			var bei = function(n){return n*base;}
			var str = text;
			if(text.length <= bei(1)){
				str = text;
			}else if(text.length > bei(1)){
				str = text.slice(0,bei(1))+'...'
			}
			return str;
		},
		//控制文字超过指定字数换行
		wrapWords: function(v,num) {
			var text = v;
			var base = num ? num : 10; //默认10个字
			var bei = function(n){return n*base;}
			var str = text;
			if(text.length <= bei(1)){
				str = text;
			}else if(text.length > bei(1) && text.length <= bei(2)){
				str = text.slice(0,bei(1))+'\n'+text.slice(bei(1))
			}else if(text.length > bei(2) && text.length <= bei(3)){
				str = text.slice(0,bei(1))+'\n'+text.slice(bei(1),bei(2))+'\n'+text.slice(bei(2))
			}else if(text.length > bei(3) && text.length <= bei(4)){
				str = text.slice(0,bei(1))+'\n'+text.slice(bei(1),bei(2))+'\n'+text.slice(bei(2),bei(3))+'\n'+text.slice(bei(3))
			}else if(text.length > bei(4)){
				str = text.slice(0,bei(1))+'\n'+text.slice(bei(1),bei(2))+'\n'+text.slice(bei(2),bei(3))+'\n'+text.slice(bei(3),bei(4))+'\n'+text.slice(bei(4))
			}
			return str;
		},
		
		/*自定义运算，实现加减乘除运算，确保不丢失精度
		 * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）*/
		operation: function(a, b, digits, op) {
			//判断obj是否为一个整数
			function isInteger(obj) { return Math.floor(obj) === obj }
			/*
			 * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
			 * @param floatNum {number} 小数
			 * @return {object} 如：{times:100, num: 314}
			 */
			function toInteger(floatNum) {
			    var ret = {times: 1, num: 0}
			    if (isInteger(floatNum)) {
			        ret.num = floatNum
			        return ret
			    }
			    var strfi  = floatNum + ''
			    var dotPos = strfi.indexOf('.')
			    var len    = strfi.substr(dotPos+1).length
			    var times  = Math.pow(10, len)
			    var intNum = parseInt(floatNum * times + 0.5, 10)
			    ret.times  = times
			    ret.num    = intNum
			    return ret
			}
		    var o1 = toInteger(a)
		    var o2 = toInteger(b)
		    var n1 = o1.num
		    var n2 = o2.num
		    var t1 = o1.times
		    var t2 = o2.times
		    var max = t1 > t2 ? t1 : t2
		    var result = null
		    switch (op) {
		        case 'add':
		            if (t1 === t2) { // 两个小数位数相同
		                result = n1 + n2
		            } else if (t1 > t2) { // o1 小数位 大于 o2
		                result = n1 + n2 * (t1 / t2)
		            } else { // o1 小数位 小于 o2
		                result = n1 * (t2 / t1) + n2
		            }
		            return result / max
		        case 'subtract':
		            if (t1 === t2) {
		                result = n1 - n2
		            } else if (t1 > t2) {
		                result = n1 - n2 * (t1 / t2)
		            } else {
		                result = n1 * (t2 / t1) - n2
		            }
		            return result / max
		        case 'multiply':
		            result = (n1 * n2) / (t1 * t2)
		            return result
		        case 'divide':
		            result = (n1 / n2) * (t2 / t1)
		            return result
		    }
		},
		
		//加
		add: function(a, b, digits) {
		   //return this.operation(a, b, digits, 'add')
			var arg1 = a;
			var arg2 = b;
			var r1,r2,m;
			try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
			try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
			m=Math.pow(10,Math.max(r1,r2))
			return (Math.round(arg1*m)+Math.round(arg2*m))/m
		},
		//减
		subtract: function(a, b, digits) {
		    return this.operation(a, b, digits, 'subtract')
		},
		//乘
		multiply: function(num1,num2) {
		    //return this.operation(a, b, digits, 'multiply')
			if(!num1 && num1!==0) return '';
			if(!num2 && num2!==0) return num1;
			var m=0, s1=num1.toString(), s2=num2.toString(); 
			try{m+=s1.split(".")[1].length}catch(e){};
			try{m+=s2.split(".")[1].length}catch(e){};
			return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
		},
		//除
		divide: function(a, b, digits) {
		    return this.operation(a, b, digits, 'divide')
		},
		
		//编码
		encode: function(str){
			return encodeURIComponent(str);
		},
		//编码
		decode: function(str){
			return decodeURIComponent(decodeURIComponent(str));
		},
		
		//保留len位小数点，（没有小数点默认不加0） num:原数字 len:要保留的位数
		toFixed: function(num,len){
			len = isNaN(len) ? 0 : len;
			var bei = Math.pow(10,len); //10的len次方
			return this.divide( Math.round(this.multiply(num,bei)), bei);
        },
        
        //控制录音播放/停止
    	contrlAudio: function(obj){
    		var _this = art(obj);
    	    var _thisAudio = _this.ele.querySelector("audio");
    	    if( _this.hasClass("play") ){
    	        //停止播放 
    	    	_this.removeClass("play");
    	        _thisAudio.pause();
    	    }else{
    	        //开始播放
    	    	stopAllExcpet(); //先停止所有的音频
    	        _this.addClass("play");
    	        _thisAudio.play();
    	        //判断是否播放完成
    	        var is_playFinish = setInterval(function(){
    	            if( _thisAudio.ended ){
    	                _this.removeClass("play");
    	                window.clearInterval(is_playFinish);
    	            }
    	        }, 100);
    	    }
    	    //先停止所有的音频/视频
    	    function stopAllExcpet(obj){
    	    	var _this = art(obj);
    	    	var audio = art('audio').ele;
    	    	var video = art('video').ele;
    	    	var audioLen = audio.length;	
    	    	var videoLen = video.length;
    	        for( var i=0; i<audioLen; i++ ){
    	        	if( audio[i]!==obj  ){
    	        		audio[i].pause();
    	        		audio[i].currentTime = 0; //回到第0秒
    	        		art(audio[i]).parent(".myaudioBox").removeClass("play");
    	        	}
    	        }
    	        for( var j=0; j<videoLen; j++ ){
    	        	if( video[j]!==obj  ){
    	        		video[j].pause();
    	        		video[j].currentTime = 0; //回到第0秒
    	        		art(video[j]).parent(".videoBox").removeClass("play");
    	        	}
    	        }
    	    }
        },

        //秒转换成时分秒second-秒
		calcDuration: function(second){
			var that = this;
			var res = {
				str: ''
			}
			if(!second && second!==0){return res;}
			var d = parseInt(second / 60 / 60 / 24);  
		    var h = parseInt(second / 60 / 60 % 24);  
		    var m = parseInt(second / 60 % 60);  
		    var s = parseInt(second % 60); 
		    var dd = (d===0) ? '' : (d+'天');
		    var hh = (h===0) ? '' : (h+'小时');
		    var mm = (m===0) ? '' : (m+'分钟');
		    var ss = (s===0) ? '' : (s+'秒');
		    var dh = dd ? (d*24 + h) : h; //小时数（去掉了分秒）
		    var hms = (dh ? that.add0(dh)+':' : '') + that.add0(m) + ':' + that.add0(s); // 00:00:00 (小时没有就00:00)
		    res = {
		    	str: dd + hh + mm + ss,
		    	hms: hms, 
		    	d: d,
		    	h: h,
		    	m: m,
		    	s: s
		    }
		    return res;
        },
        //替换换行符号\n=><br/> ; 还原换行符号<br/>=>\n
		replaceNewline: function(str,restore){
			var newStr = '';
			if( !str && str!==0 ) return '';
			var reg1 = /\n/ig;
			var reg2 = new RegExp('<br/>|<br>','gi');
			//还原换行符号
			if( restore ){
				var 
				newStr = str.replace(reg2,'\n');
			}
			//替换换行符号
			else{
				newStr = str.replace(reg1,'<br/>');
			}
			return newStr;
		},

		//解决e-image点击后body不能滚动的问题
		delayRollAuto(){
			setTimeout(()=>{
				document.body.style.overflow = 'auto';
			},100)
        },
        //跳转社区大讲堂
        openShequCourse:function(){
            window.open(base.shequUrl, '_blank');
        },
        //跳转社区大讲堂课程
        openShequCourseDetail:function(courseId){
            window.open(base.shequUrl+'/detail?courseId='+courseId, '_blank');
        },

        //工作室等级
        getStudioLevels: function(back){
            var a = sessionStorage.getItem('studioLevels');
            if(a){
                back(JSON.parse(a));
            }else{
                api.pub.getStudioLevels({}).then(res=>{
                    sessionStorage.setItem('studioLevels',JSON.stringify(res.body.sysDictList))
                    back(res.body.sysDictList);
                }).catch(res=>{})
            }
        },
	} 

	//把artFun 对象的方式属性复制给myqeruy
	for( var name in artFun ){
		myquery[name] = artFun[name];
	}

    w.art = w.artTool = myquery; //类追加到全局对象自定义属性上，可直接调用
}(window))